module.exports = __webpack_public_path__ + "static/media/hansa.c227ee17.ogg";